var map = {
	"./decidim/avatar-multiuser.png": 6684,
	"./decidim/brands/facebook.svg": 69202,
	"./decidim/brands/google.svg": 42163,
	"./decidim/brands/twitter-x.svg": 62448,
	"./decidim/cc-badge.png": 92942,
	"./decidim/decidim-logo.svg": 71646,
	"./decidim/default-avatar.svg": 67786,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 66142,
	"./decidim/icons.svg": 89021,
	"./decidim/pattern.png": 88506,
	"./decidim/placeholder-card-g.svg": 47895,
	"./decidim/placeholder-card-l.svg": 82572,
	"./decidim/placeholder.jpg": 8275,
	"./decidim/remixicon.symbol.svg": 42075,
	"./decidim/vendor/social-share-button/douban.svg": 49962,
	"./decidim/vendor/social-share-button/email.svg": 70279,
	"./decidim/vendor/social-share-button/facebook.svg": 11001,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 56571,
	"./decidim/vendor/social-share-button/hacker_news.svg": 34827,
	"./decidim/vendor/social-share-button/linkedin.svg": 36087,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 81904,
	"./decidim/vendor/social-share-button/pinterest.svg": 18473,
	"./decidim/vendor/social-share-button/reddit.svg": 23225,
	"./decidim/vendor/social-share-button/telegram.svg": 22592,
	"./decidim/vendor/social-share-button/tumblr.svg": 90327,
	"./decidim/vendor/social-share-button/twitter.svg": 45654,
	"./decidim/vendor/social-share-button/vkontakte.svg": 92872,
	"./decidim/vendor/social-share-button/wechat.svg": 41555,
	"./decidim/vendor/social-share-button/whatsapp.svg": 88075,
	"./decidim/vendor/social-share-button/x.svg": 83807,
	"./decidim/vendor/social-share-button/xing.svg": 67513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89835;